/**
 * QuietBar - Stealth's proposal, on the GM's screen.
 *
 * - A player's REQUEST (their quiet move waiting to be rolled) is a row of
 *   the asks tray since v9.5.3 (`components/asks/rows.jsx`), so it is seen
 *   in every mode.
 * - A PROPOSAL is what the last move suggests for the ladder. Accept it,
 *   or leave the ladder where it is. Pressing a rung on the ladder itself
 *   is always open as well.
 *
 * Draws nothing when there is neither, which is always the case for a
 * player.
 *
 * @param {object} props
 * @param {object} props.quiet - hooks/useShellQuietMoves
 * @param {string} props.rung - the ladder's rung now, to say what accepting would change
 */
import common from '../../styles/common.module.css';
import styles from '../../styles/CallForTest.module.css';
import { RUNG_LABELS } from '../../engine/stealth/ladder';

function Proposal({ proposal, rung, quiet }) {
  const moves = proposal.rung !== rung;
  return (
    <div className={styles.callLine} data-testid="quiet-proposal">
      <span>
        {proposal.title}. {proposal.reason}
      </span>
      {moves && (
        <button type="button" className={common.btnDodge} data-testid="quiet-accept" onClick={quiet.accept}>
          Move to {RUNG_LABELS[proposal.rung]}
        </button>
      )}
      <button type="button" className={common.btnSmall} data-testid="quiet-leave" onClick={quiet.leave}>
        {moves ? 'Leave the ladder' : 'Done'}
      </button>
    </div>
  );
}

export default function QuietBar({ quiet, rung }) {
  if (!quiet.proposal) return null;
  return (
    <div className={styles.calls} role="status" data-testid="quiet-bar">
      <Proposal proposal={quiet.proposal} rung={rung} quiet={quiet} />
    </div>
  );
}
